import { TypedDocumentNode, gql } from '@apollo/client';

import { updatePartnerOffersAgreementInput } from '__generated__/globalTypes';
import { useMutation } from 'hooks/graphql/useMutation';

import {
  UpdatePartnerOffersAgreementMutation,
  UpdatePartnerOffersAgreementMutationVariables,
} from './__generated__/index.graphql';

const UPDATE_PARTNER_OFFERS_AGREEMENT = gql`
  mutation UpdatePartnerOffersAgreementMutation(
    $input: updatePartnerOffersAgreementInput!
  ) {
    updatePartnerOffersAgreement(input: $input) {
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdatePartnerOffersAgreementMutation,
  UpdatePartnerOffersAgreementMutationVariables
>;

export const useUpdatePartnerOffersAgreement = () => {
  const [mutate] = useMutation(UPDATE_PARTNER_OFFERS_AGREEMENT);

  return async (input: updatePartnerOffersAgreementInput) => {
    return mutate({
      variables: { input },
    });
  };
};
